export const colors = {
  primary: "",

  pinkColor: "#FBBDB0",

  textColor: "#1F1F1F",
  textColor2: "#232323",
  textColor3: "#2E2E2E",

  lightColor: "#3D3D3D",
};
